import api from '../axios.config';
import { API_ENDPOINTS, createEndpoint } from './endpoints';

export const UserService = {
  loginUser: async (userData) => {
    const response = await api.post(API_ENDPOINTS.USER.LOGIN, userData);
    return response;
  },

  logoutUser: async (userData) => {
    const response = await api.post(API_ENDPOINTS.USER.LOGOUT, userData);
    return response;
  },

  changePassword: async (data) => {
    const response = await api.post(API_ENDPOINTS.USER.CHANGE_PASSWORD, data);
    return response;
  },

  getAhedgeUsers: async (role, pageNo = 1, pageSize = 10) => {
    // If role is 'all', don't send role parameter — `undefined`, not an
    // empty string. createEndpoint only drops a query segment for
    // undefined/null values (confirmed in endpoints.jsx); an empty string
    // still gets encoded as the literal `role=`, which the backend reads as
    // "role equals empty string" — zero matches — not "no role filter".
    // That's what this comment always intended, it just didn't do it:
    // confirmed live, `role=` returned `users: []` against a real, non-empty
    // user table.
    const params =
      role === 'all'
        ? { role: undefined, pageNo, pageSize }
        : { role, pageNo, pageSize };
    const endpoint = createEndpoint(
      API_ENDPOINTS.USER.GET_AHEDGE_USERS,
      params
    );
    const response = await api.get(endpoint);
    return response;
  },

  createAhedgeUser: async (userData) => {
    const response = await api.post(
      API_ENDPOINTS.USER.CREATE_AHEDGE_USER,
      userData
    );
    return response;
  },

  deactivateUser: async (userId) => {
    const endpoint = createEndpoint(API_ENDPOINTS.USER.DEACTIVATE_USER, {
      id: userId,
    });
    const response = await api.patch(endpoint);
    return response;
  },

  activateUser: async (userId) => {
    const endpoint = createEndpoint(API_ENDPOINTS.USER.ACTIVATE_USER, {
      id: userId,
    });
    const response = await api.post(endpoint);
    return response;
  },

  // Method/payload confirmed — see ASSIGN_ROLES's own comment in
  // endpoints.jsx for the one still-open detail (the path's `/internal`
  // prefix). `roles` is the full desired set of role values (e.g.
  // ['ahedge_ta', 'ahedge_interviewer']), not a delta, matching how
  // AssignRoleModal itself tracks selection (pre-checked from the user's
  // current roles).
  assignRoles: async (userId, roles) => {
    const endpoint = createEndpoint(API_ENDPOINTS.USER.ASSIGN_ROLES, {
      id: userId,
    });
    const response = await api.put(endpoint, { roles });
    return response;
  },
};
